export enum DocumentType {
  OfficialIdentification,
  CURP,
  ProofOfAddress,
  DeclarationOfKnowledgeOfTheBeneficialOwner,
  ConstitutiveAct,
  TaxIdentificationConstance,
  PowerOfTheLegalRepresentative,
  ActOfAssemblyProtocolizedWithPowersOfAttorney,
  ConstitutionOfTheTrust,
  PowersOrFiduciaryDelegate,
  CedulaRFC,
  LeasingContract,
  Notification,
  DeliveredNotification,
  OperationExcel,
  PowerOfAttorneyOfTheObligatedSubject,
  Invoice,
  CIF,
  ImmigrationDocument,
  NoticeDetailReport,
  ConsularRegistrationCertificate,
  ConfirmDocument,
  FollowUp,
  ProofOfPayment,
  ApprovedQuote,
  REPUVE,
  OutputSheet,
  FileVerificationLetter,
  LetterOfConformity,
  AdhesionContract,
  ElectronicPaymentReceipt,
  InvoicePDF,
  CustomerAccountStatement,
  BillingPermission,
  OutputSheetPermission,
  SubjectObligedLogo,
  Netting,
  DeclarationOfKnowledgeOfTheBeneficialOwnerUnsigned,
  CsnuPDF,
  NewsletterImage,
  HomeCredit,
  VideoThumbnail,
  VideoDocument,
  DisbursementValidation,
  TreasuryAuthorization,
  CashRestrictionLetter,
  NoticeOfPrivacy,
  ContractDocument,
  FinalBeneficiaryLogo,
  CoOwnerParticipationProof,
  StatementCashUsageRestriction,
  PrivacyNotice,
  BankAccountStatement
}
